import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import InfoIcon from "../../images/icons/info.svg"
import FpTooltip from "../tooltip/tooltip"
import "./info.sass"

const Info = ({ label, customClassName }) => {
  return (
    <>
      {label && (
        <FpTooltip label={label}>
          <div className={classNames("_fp-info", customClassName)}>
            <InfoIcon />
          </div>
        </FpTooltip>
      )}
    </>
  )
}

Info.propTypes = {
  label: PropTypes.string,
  customClassName: PropTypes.string,
}

export default Info
